import {
  accessControlURL,
  camerasURL,
} from '../ExternalAccountsSettings/constants';

import {
  accessCardBreadcrumbs,
  accessPointBreadcrumbs,
  amenityBreadcrumbs,
  amenityReservationBreadcrumbs,
  buildingBreadcrumbs,
  cameraBreadcrumbs,
  communityBreadcrumbs,
  deliveryTypesBreadcrumbs,
  doorBreadcrumbs,
  eventBreadcrumbs,
  externalAccountBreadcrumbs,
  personBreadcrumbs,
  personSearchBreadcrumbs,
  pmcBreadcrumbs,
  residentBreadcrumbs,
  serviceRequestBreadcrumbs,
  unitBreadcrumbs,
  visitorBreadcrumbs,
  visitorUpdateBreadcrumbs,
} from './DynamicBreadcrumbs';

export const routes = [
  { path: '/pmcs', breadcrumb: 'Property Management Companies' },
  { path: '/pmc/create', breadcrumb: 'Create PMC' },
  { path: '/pmc/:pmcId', breadcrumb: pmcBreadcrumbs },
  { path: '/pmc/:pmcId/buildings', breadcrumb: 'Buildings' },
  { path: '/pmc/:pmcId/staff', breadcrumb: 'Staff' },
  { path: '/pmc/:pmcId/staff/create', breadcrumb: 'Create' },
  { path: '/pmc/:pmcId/staff/:personId', breadcrumb: personBreadcrumbs },
  {
    path: '/pmc/:pmcId/all-doors-and-cameras/camera-history',
    breadcrumb: 'Camera History',
  },
  { path: '/pmc/:pmcId/all-doors-and-cameras', breadcrumb: 'Doors & Cameras' },
  { path: '/pmc/:pmcId/messages', breadcrumb: 'Messages' },
  { path: '/pmc/:pmcId/deliveries', breadcrumb: 'Deliveries' },
  { path: '/pmc/:pmcId/service-requests', breadcrumb: 'Service Requests' },
  {
    path: '/pmc/:pmcId/settings/src',
    breadcrumb: 'Service Requests Categories',
  },
  {
    path: '/pmc/:pmcId/visitors/manage/create-visitor',
    breadcrumb: 'Create Visitor',
  },
  {
    path: '/pmc/:pmcId/visitors/manage/create-broker',
    breadcrumb: 'Create Broker',
  },
  { path: '/pmc/:pmcId/visitors', breadcrumb: 'Visitor Management' },
  { path: '/pmc/:pmcId/document-library', breadcrumb: 'Document Library' },
  {
    path: '/pmc/:pmcId/amenity/management/info/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/pmc/:pmcId/amenity/management/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/pmc/:pmcId/amenity/reservations/:id',
    breadcrumb: amenityReservationBreadcrumbs,
  },
  { path: '/pmc/:pmcId/amenity', breadcrumb: 'Amenity Reservations' },
  { path: '/pmc/:pmcId/update', breadcrumb: 'Details' },
  { path: '/pmc/:pmcId/leasing-inquiries', breadcrumb: 'Leasing Inquiries' },
  { path: '/building/create', breadcrumb: 'Create Building' },
  { path: '/building/:buildingId', breadcrumb: buildingBreadcrumbs },
  {
    path: '/building/:buildingId/all-doors-and-cameras/camera-history',
    breadcrumb: 'Camera History',
  },
  {
    path: '/building/:buildingId/all-doors-and-cameras',
    breadcrumb: 'Doors & Cameras',
  },
  {
    path: '/building/:buildingId/access-points',
    breadcrumb: 'Access Points',
  },
  {
    path: '/building/:buildingId/entry-log',
    breadcrumb: 'Entry Log',
  },
  {
    path: '/building/:buildingId/service-requests',
    breadcrumb: 'Service Requests',
  },
  {
    path: '/building/:buildingId/service-request-categories',
    breadcrumb: 'Service Requests Categories',
  },
  {
    path: '/building/:buildingId/document-library',
    breadcrumb: 'Document Library',
  },
  {
    path: '/building/:buildingId/update',
    breadcrumb: 'Details',
  },
  {
    path: '/building/:buildingId/staff/create',
    breadcrumb: 'Create',
  },
  {
    path: '/building/:buildingId/staff/:personId',
    breadcrumb: personBreadcrumbs,
  },
  {
    path: '/building/:buildingId/residents/import',
    breadcrumb: 'Import',
  },
  {
    path: '/building/:buildingId/residents/create',
    breadcrumb: 'Create',
  },
  {
    path: '/building/:buildingId/residents/create-in-unit/:unitId',
    breadcrumb: unitBreadcrumbs,
  },
  {
    path: '/building/:buildingId/residents/:personId',
    breadcrumb: residentBreadcrumbs,
  },
  {
    path: '/building/:buildingId/units/create',
    breadcrumb: 'Create',
  },
  {
    path: '/building/:buildingId/units/:unitId',
    breadcrumb: unitBreadcrumbs,
  },
  {
    path: '/building/:buildingId/cameras/create',
    breadcrumb: 'Create',
  },
  {
    path: '/building/:buildingId/cameras/:cameraId',
    breadcrumb: cameraBreadcrumbs,
  },
  {
    path: '/building/:buildingId/access-points/create',
    breadcrumb: 'Create',
  },
  {
    path: '/building/:buildingId/access-points/:accessPointId',
    breadcrumb: accessPointBreadcrumbs,
  },
  {
    path: '/building/:buildingId/doors/create',
    breadcrumb: 'Create',
  },
  {
    path: '/building/:buildingId/doors/:doorId',
    breadcrumb: doorBreadcrumbs,
  },
  {
    path: '/building/:buildingId/visitors/manage/create-visitor',
    breadcrumb: 'Create Visitor',
  },
  {
    path: '/building/:buildingId/visitors/manage/create-broker',
    breadcrumb: 'Create Broker',
  },
  {
    path: '/building/:buildingId/amenity/management/info/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/building/:buildingId/amenity/management/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/building/:buildingId/amenity/reservations/:id',
    breadcrumb: amenityReservationBreadcrumbs,
  },
  { path: '/building/:buildingId/amenity', breadcrumb: 'Amenity Reservations' },
  {
    path: '/building/:buildingId/remote-doorman-notifications',
    breadcrumb: 'Remote Doorman Notifications',
  },
  {
    path: '/building/:buildingId/remote-doorman-notifications/leasing-inquiries',
    breadcrumb: 'Leasing Inquiries',
  },
  {
    path: '/building/:buildingId/remote-doorman-notifications/courier-error-reports',
    breadcrumb: 'Courier Error Reports',
  },
  {
    path: '/building/:buildingId/visitors',
    breadcrumb: 'Visitor Management',
  },
  {
    path: '/building/:buildingId/building-operations',
    breadcrumb: 'Building Operations',
  },
  {
    path: '/building/:buildingId/front-desk',
    breadcrumb: 'front desk dashboard',
  },
  {
    path: '/building/:buildingId/home-feed/create',
    breadcrumb: 'Create Card',
  },
  {
    path: '/building/:buildingId/home-feed/:cardId',
    breadcrumb: 'Update Card',
  },
  {
    path: '/building/:buildingId/home-feed',
    breadcrumb: 'Home Feed',
  },
  {
    path: '/building/:buildingId/building-guide/create',
    breadcrumb: 'Create Card',
  },
  {
    path: '/building/:buildingId/building-guide/:cardId',
    breadcrumb: 'Update Card',
  },
  {
    path: '/building/:buildingId/building-guide',
    breadcrumb: 'Building Guide',
  },
  {
    path: '/building/:buildingId/your-wellbeing/create',
    breadcrumb: 'Create Card',
  },
  {
    path: '/building/:buildingId/your-wellbeing/:cardId',
    breadcrumb: 'Update Card',
  },
  {
    path: '/building/:buildingId/your-wellbeing',
    breadcrumb: 'Your Wellbeing',
  },
  {
    path: '/building/:buildingId/settings/accounts/accounting-account/yardi/:id/:type',
    breadcrumb: 'Yardi',
  },
  {
    path: '/building/:buildingId/settings/accounts/accounting-account/yardi-file-import/:id/',
    breadcrumb: 'Yardi',
  },
  {
    path: '/global-person-search/profile',
    breadcrumb: 'Profile',
  },
  {
    path: '/global-person-search/create',
    breadcrumb: 'Add Admin User',
  },
  {
    path: '/global-person-search/:personId',
    breadcrumb: personSearchBreadcrumbs,
  },
  {
    path: '/global-person-search',
    breadcrumb: 'Global Person Search',
  },
  {
    path: '/ip-management',
    breadcrumb: 'IP Management',
  },
  {
    path: '/carson-activity/:personId',
    breadcrumb: personBreadcrumbs,
  },
  {
    path: '/carson-activity',
    breadcrumb: 'Carson Activity',
  },
  {
    path: '/external-accounts-settings/access-control-account/brivo/clear-users',
    breadcrumb: 'Clear Users',
  },
  {
    path: '/external-accounts-settings',
    breadcrumb: 'External Accounts',
  },
  {
    path: `${accessControlURL}`,
    breadcrumb: 'Access Control',
  },
  {
    path: `${accessControlURL}/two-n`,
    breadcrumb: '2N',
  },
  {
    path: `${accessControlURL}/akuvox`,
    breadcrumb: 'Akuvox',
  },
  {
    path: `${camerasURL}/eagle-eye`,
    breadcrumb: 'Eagle Eye',
  },
  {
    path: '/external-accounts-settings/:type/:account/update/:accountId',
    breadcrumb: externalAccountBreadcrumbs,
  },
  {
    path: '/access-points',
    breadcrumb: 'Access Points',
  },
  {
    path: '/service-requests',
    breadcrumb: 'Service Requests',
  },
  {
    path: '/service-requests/create',
    breadcrumb: 'Create',
  },
  {
    path: '/service-requests/:serviceRequestId',
    breadcrumb: serviceRequestBreadcrumbs,
  },
  {
    path: '/visitors/manage/update-visitor/:visitorId',
    breadcrumb: visitorBreadcrumbs,
  },
  {
    path: '/visitors/manage/update-broker/:personId',
    breadcrumb: visitorUpdateBreadcrumbs,
  },
  {
    path: '/visitors/manage/update-prospective-tenant/:visitorId',
    breadcrumb: visitorBreadcrumbs,
  },
  {
    path: '/visitors/manage/create-visitor',
    breadcrumb: 'Create Visitor',
  },
  {
    path: '/visitors/manage/create-broker',
    breadcrumb: 'Create Broker',
  },
  {
    path: '/visitors/log',
    breadcrumb: 'Log',
  },
  {
    path: '/visitors/profile/:visitorId',
    breadcrumb: visitorBreadcrumbs,
  },
  {
    path: '/visitors',
    breadcrumb: 'Visitor Management',
  },
  {
    path: '/access-cards/batches-list/:id',
    breadcrumb: accessCardBreadcrumbs,
  },
  { path: '/access-cards/batches-list', breadcrumb: 'Access Card Batches' },
  { path: '/access-cards/list/:id', breadcrumb: accessCardBreadcrumbs },
  { path: '/access-cards/list', breadcrumb: 'Access Cards' },
  {
    path: '/document-library',
    breadcrumb: 'Document Library',
  },
  {
    path: '/notification-preferences',
    breadcrumb: 'Notification Preferences',
  },
  {
    path: '/exports/sr',
    breadcrumb: 'Service Requests',
  },
  {
    path: '/exports/visitor-log',
    breadcrumb: 'Visitors Log',
  },
  {
    path: '/deliveries/management/:id',
    breadcrumb: deliveryTypesBreadcrumbs,
  },
  {
    path: '/deliveries/list',
    breadcrumb: 'Deliveries List',
  },
  {
    path: '/deliveries/management',
    breadcrumb: 'Delivery Types Management',
  },
  {
    path: '/amenity/management/info/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/amenity/management/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/amenity/reservations/:id',
    breadcrumb: amenityReservationBreadcrumbs,
  },
  { path: '/amenity', breadcrumb: 'Amenity Reservations' },
  {
    path: '/external-accounts-settings/access-control-account/dormakaba',
    breadcrumb: 'Dormakaba',
  },
  {
    path: `${accessControlURL}/lyazon`,
    breadcrumb: 'Lyazon',
  },
  {
    path: `${accessControlURL}/zerv`,
    breadcrumb: 'Zerv',
  },
  {
    path: `${accessControlURL}/salto`,
    breadcrumb: 'Salto',
  },
  {
    path: `${accessControlURL}/keyscan`,
    breadcrumb: 'Keyscan',
  },
  {
    path: '/external-accounts-settings/custom-integrations/external-links',
    breadcrumb: 'External Links',
  },
  {
    path: '/external-accounts-settings/custom-integrations',
    breadcrumb: 'Custom Integrations',
  },
  {
    path: '/camera-history',
    breadcrumb: 'Camera History',
  },
  {
    path: '/billing-report',
    breadcrumb: 'Monthly Bill',
  },
  {
    path: '/community/list/:id',
    breadcrumb: communityBreadcrumbs,
  },
  {
    path: '/community/content-approval',
    breadcrumb: 'Content Approval',
  },
  {
    path: '/remote-doorman/agents-list',
    breadcrumb: 'Agents List',
  },
  {
    path: '/remote-doorman/agents-log',
    breadcrumb: 'Agents Log',
  },
  {
    path: '/remote-doorman/agents-management',
    breadcrumb: 'Agent Management',
  },
  {
    path: '/remote-doorman/calls',
    breadcrumb: 'Calls Log',
  },
  {
    path: '/remote-doorman/pop-ups',
    breadcrumb: 'Building Pop Ups',
  },
  {
    path: '/remote-doorman',
    breadcrumb: 'Remote Doorman',
  },
  {
    path: '/terms-and-conditions',
    breadcrumb: 'Terms Of Service',
  },
  {
    path: '/privacy-policy',
    breadcrumb: 'Privacy Policy',
  },
  {
    path: '/events/details/:id',
    breadcrumb: eventBreadcrumbs,
  },
  {
    path: '/events/details/:id/rsvps',
    breadcrumb: `manage RSVPS`,
  },
  {
    path: '/events/add',
    breadcrumb: 'Add event',
  },
  {
    path: '/events/:id',
    breadcrumb: 'Edit event',
  },
];

export const config = {
  excludePaths: [
    '/',
    '/pmc',
    '/building',
    '/pmc/:pmcId/staff/:personId/roles',
    '/pmc/:pmcId/visitors/manage',
    '/pmc/:pmcId/amenity/:type/info',
    '/pmc/:pmcId/amenity/:type',
    '/building/:buildingId/staff/:personId/roles',
    '/building/:buildingId/residents/:personId/roles',
    '/building/:buildingId/settings/:type',
    '/building/:buildingId/settings/:type/:provider',
    '/building/:buildingId/settings/:type/:provider/:id',
    '/building/:buildingId/visitors/manage',
    '/building/:buildingId/amenity/:type/info',
    '/building/:buildingId/amenity/:type',
    '/users',
    '/external-accounts-settings/:type/:account/update/',
    '/external-accounts-settings/access-control-account/brivo/clear-users/:accountId',
    '/visitors/manage/update-visitor',
    '/visitors/manage/update-broker',
    '/visitors/manage/update-prospective-tenant',
    '/visitors/manage',
    '/visitors/profile',
    '/visitors/update',
    '/visitors/list',
    '/messages/:id',
    '/pmc/:pmcId/messages/:id',
    '/building/:buildingId/messages/:id',
    '/access-cards',
    '/building/:buildingId/residents/create-in-unit',
    '/deliveries',
    '/amenity/:type/info',
    '/amenity/:type',
    '/amenity/reservations/list',
    '/amenity/reservations/calendar',
    '/pmc/:pmcId/amenity/reservations/list',
    '/pmc/:pmcId/amenity/reservations/calendar',
    '/building/:buildingId/amenity/reservations/list',
    '/building/:buildingId/amenity/reservations/calendar',
    '/building/:buildingId/settings/accounts/accounting-account/yardi/:id/',
    '/community/list',
    '/community/messages/:id',
    '/events/details/:id/lists',
    '/events/details/',
  ],
};
